import platformImg from "../images/chit-hero.png";
import modulesImg from "../images/chittyimage1.png";
import securityImg from "../images/security.jpg";
import analyticsImg from "../images/reporting.jpg";
import React, { useState, useEffect } from "react";
import "./ChitPage.css";
import BASE_URL from "../apiConfig";
import useRecaptcha from "../hooks/useRecaptcha";
import technopark from "../images/technopark.jpg";

function ChitPage() {
  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    email: "",
    organization: "",
    challenges: ""
  });
  const [widgetId, setWidgetId] = useState(null);
  const { getResponse } = useRecaptcha();

  useEffect(() => {
    if (window.grecaptcha) {
      const container = document.getElementById("recaptcha-chit");
      if (container && container.innerHTML === "") {
        try {
          const id = window.grecaptcha.render(container, {
            // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
             sitekey: window.RECAPTCHA_SITE_KEY,
          });
          setWidgetId(id);
        } catch (err) {
          console.error("reCAPTCHA ChitPage render error:", err);
        }
      }
    }
  }, []);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.full_name || !formData.phone) {
      setMessage("❌ Name & Phone required");
      return;
    }

    const token = getResponse(widgetId);
    if (!token) {
      setMessage("❌ Please complete the reCAPTCHA");
      setLoading(false);
      return;
    }
    const fd = new FormData();
    Object.keys(formData).forEach(k => fd.append(k, formData[k]));
    fd.append("_type", "chit_demo");
    fd.append("tk", token);

    try {
      const res = await fetch(
        BASE_URL + "/DemoApi/saveData",
        { method: "POST", body: fd }
      );

      const result = await res.json();

      if (result.status) {
        setMessage("✅ Demo Request Submitted");
        setFormData({
          full_name: "",
          phone: "",
          email: "",
          organization: "",
          challenges: ""
        });
      } else {
        setMessage("❌ " + (result.message || "Verification Failed"));
      }

    } catch (err) {
      console.error("Submission Error:", err);
      setMessage("❌ Submission Failed. Check Console.");
    }

    setLoading(false);
  };

  return (
    <>
      {/* HERO SECTION */}
      <div
        className="bg-container-chit"
        style={{ backgroundImage: `url(${technopark})` }}
      ></div>

      <div className="chit-wrapper">
        <div className="chit-left">
          <h1>IGNOSI- BID</h1>
          <h2>Complete Chit Fund Management System</h2>
          <h3>Automate subscriber enrollment, auctions, and collections.</h3>

          <p>
            Manage schemes, auctions, subscribers and compliance through a unified digital ecosystem. Automate subscriber enrollment, auctions, collections and regulator-ready reporting with an end-to-end chit management platform.
          </p>

          <ul>
            <li>Digital Chit Scheme Automation</li>
            <li>Auction & Bid Management</li>
            <li>Collection & Prize Disbursement</li>
            <li>Regulatory Compliance Ready</li>
          </ul>
        </div>

        <div className="chit-right">
          <form className="demo-form-chit" onSubmit={handleSubmit}>
            <input
              name="full_name"
              placeholder="Full Name*"
              value={formData.full_name}
              onChange={handleChange}
            />

            <input
              name="phone"
              placeholder="Phone Number*"
              value={formData.phone}
              onChange={handleChange}
            />

            <input
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
            />

            <input
              name="organization"
              placeholder="Organization Name"
              value={formData.organization}
              onChange={handleChange}
            />

            <textarea
              name="challenges"
              placeholder="What challenges are you looking to solve?"
              value={formData.challenges}
              onChange={handleChange}
            />

            <div
              id="recaptcha-chit"
              style={{ marginBottom: "15px" }}
            ></div>

            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Book a Demo"}
            </button>

            {message && <p className="form-msg-chit">{message}</p>}
          </form>
        </div>
      </div>

      {/* PLATFORM INTRO */}
      <div className="chit-intro-wrapper">
        <div className="chit-intro-section animate-fadeInUp">
          <div className="intro-content">
            <h2 className="gradient-text">End-to-End Chit Fund Management Platform</h2>
            <p>
              Manage schemes, auctions, subscribers and compliance through a unified digital ecosystem. A complete solution for the modern chit fund foreman.
            </p>
          </div>
          <div className="intro-image animate-fadeInUp">
            <img src={platformImg} alt="Platform Visualization" />
          </div>
        </div>
      </div>

      {/* FLOW */}
      <div className="chit-flow-section">
        <div className="chit-flow-grid">
          {[
            "Scheme Creation",
            "Subscriber Enrollment",
            "Auction & Bidding",
            "Collection Tracking",
            "Prize Disbursement",
            "Compliance Reporting",
            "Online hybrid Auction room"
          ].map((step, idx) => (
            <div key={idx} className="flow-card animate-fadeInUp" style={{ animationDelay: `${idx * 0.1}s` }}>
              {step}
            </div>
          ))}
        </div>
      </div>

      {/* CORE MODULES */}
      <div className="modules-section-chit vibrant-bg">
        <div className="section-header center">
          <h2 className="section-title white-text animate-fadeInUp">Core Chit Fund Modules</h2>
        </div>

        <div className="modules-content-wrapper">
          <div className="modules-grid-chit">
            {[
              {
                title: "Chit Scheme Management",
                list: [
                  "Multiple Scheme Configuration",
                  "Flexible Subscription Plans",
                  "Foreman Commission Automation",
                  "Scheme Lifecycle Tracking"
                ]
              },
              {
                title: "Subscriber Management",
                list: [
                  "Digital Enrollment & eKYC",
                  "Chittal Database",
                  "Nominee Management",
                  "Exit & Transfer Handling",
                  "Chitty Mobile Passbook"
                ]
              },
              {
                title: "Auction & Bidding",
                list: [
                  "Online / Offline Auctions",
                  "Auto & Manual Bid Processing",
                  "Winner Declaration",
                  "Tie Breaker Handling with digital system"
                ]
              },
              {
                title: "Collection & Payments",
                list: [
                  "Installment Collection",
                  "Bulk Receipts",
                  "Prize Disbursement",
                  "Dividend Settlement"
                ]
              }
            ].map((mod, i) => (
              <div key={i} className="module-card-vibrant animate-fadeInUp" style={{ animationDelay: `${i * 0.1}s` }}>
                <h3>{mod.title}</h3>
                <ul>
                  {mod.list.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="modules-image-side animate-fadeInUp">
            <img src={modulesImg} alt="Modules Icons" />
          </div>
        </div>
      </div>

      {/* SECURITY */}
      <div className="security-section-chit dark-bg">
        <div className="security-layout">
          <div className="security-image animate-fadeInUp">
            <img src={securityImg} alt="Security Visualization" />
          </div>
          <div className="security-content">
            <h2 className="section-title white-text animate-fadeInUp">Security & Risk Management</h2>
            <div className="security-grid-vibrant">
              {[
                "Subscriber KYC Verification",
                "Fraud Detection",
                "Bid Collusion Monitoring",
                "Foreman OTP Authentication",
                "Secure Document Repository",
                "Chitty Balancesheet",
                "Chitty Agent Mobile Collection App"
              ].map((sec, idx) => (
                <div key={idx} className="security-item-vibrant animate-fadeInUp" style={{ animationDelay: `${idx * 0.1}s` }}>
                  <span>{sec}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* REPORTING */}
      <div className="report-section-chit gradient-bg">
        <div className="report-header">
          <h2 className="section-title white-text animate-fadeInUp">Reporting & Business Intelligence</h2>
        </div>
        <div className="report-content-vibrant">
          <div className="report-grid-vibrant">
            {[
              "Real-Time Dashboard",
              "Auction Analytics",
              "Chittal Performance Reports",
              "Collection Efficiency",
              "Cash Flow Forecasting"
            ].map((item, i) => (
              <div key={i} className="report-card-vibrant animate-fadeInUp" style={{ animationDelay: `${i * 0.1}s` }}>
                {item}
              </div>
            ))}
          </div>
          <div className="report-image animate-fadeInUp">
            <img src={analyticsImg} alt="Analytics Visualization" />
          </div>
        </div>
      </div>

      {/* WHY IGNOSI */}
      <div className="why-section-chit accent-bg">
        <h2 className="why-title-chit white-text animate-fadeInUp">Why IGNOSI for Chit Funds?</h2>

        <div className="why-grid-chit grid-5">
          {[
            "100% Regulatory Compliance",
            "Scale up to 100,000+ Subscribers",
            "Operational Risk Reduction",
            "Transparent Chittal Experience",
            // "Cloud & On-Premise Deployment"
            "Cloud & On-Premise online SaaS model chitty Software"

          ].map((item, idx) => (
            <div key={idx} className="why-card-vibrant animate-fadeInUp" style={{ animationDelay: `${idx * 0.1}s` }}>
              {item}
            </div>
          ))}
        </div>
      </div>

    </>
  );
}

export default ChitPage;
